import React from "react";
import { Box, Typography } from "@mui/material";

import { brand, fonts } from "../../themes/theme";

/**
 * KPI reutilizable: etiqueta + valor grande + nota opcional. La cifra usa la
 * fuente display de marca (Recoleta), peso normal (sin negrita), para un look
 * cuidado. Colores por tokens del tema via `tone`/`hintTone`.
 *
 * @param {string} label   - descripcion del indicador (i18n en la vista)
 * @param {string|number|node} value - valor principal
 * @param {'default'|'primary'|'accent'} tone - color del valor
 * @param {string} hint    - nota/aclaracion opcional
 * @param {'muted'|'accent'|'primary'} hintTone - color de la nota
 */
function KpiStat({ label, value, tone = "default", hint, hintTone = "muted", compact = false }) {
    const toneColor = {
        default: "text.primary",
        primary: "primary.main",
        accent: "accent.main",
    };
    const hintColor = {
        muted: brand.gray500,
        accent: brand.accent,
        primary: brand.primary,
    };

    return (
        <Box>
            <Typography sx={{ fontSize: compact ? 11.5 : 12.5, color: "text.secondary", letterSpacing: "0.01em" }}>
                {label}
            </Typography>
            <Typography
                sx={{
                    fontFamily: fonts.display,
                    fontWeight: 400,
                    fontSize: compact ? { xs: 22, md: 26 } : { xs: 26, md: 30 },
                    lineHeight: 1.15,
                    mt: compact ? 0.35 : 0.75,
                    color: toneColor[tone] || toneColor.default,
                }}
            >
                {value}
            </Typography>
            {hint && (
                <Typography
                    sx={{
                        fontSize: compact ? 11.5 : 12.5,
                        mt: compact ? 0.35 : 0.75,
                        color: hintColor[hintTone] || hintColor.muted,
                        lineHeight: 1.35,
                    }}
                >
                    {hint}
                </Typography>
            )}
        </Box>
    );
}

export default KpiStat;
